import type { InvoiceItemKind, InvoiceStatus } from '@rfleet/shared';

export interface InvoiceRow {
  id: string;
  number: string;
  status: InvoiceStatus;
  issueDate: string;
  dueDate: string | null;
  currency: string;
  subtotalEgp: string | number;
  taxRatePct: string | number;
  taxEgp: string | number;
  totalEgp: string | number;
  paidEgp: string | number;
  paidAt: string | null;
  sentAt: string | null;
  notes: string | null;
  pdfFileId: string | null;
  uploadedFileId: string | null;
  createdAt: string;
  customer: { id: string; name: string; phone: string | null; taxId: string | null };
  trip: { id: string; number: string } | null;
  _count?: { items: number };
}

export interface InvoiceItem {
  id: string;
  kind: InvoiceItemKind;
  description: string;
  quantity: string | number;
  unitPriceEgp: string | number;
  totalEgp: string | number;
  expenseId: string | null;
  sortOrder: number;
}

export interface InvoiceDetail extends Omit<InvoiceRow, 'customer' | 'trip'> {
  customer: { id: string; name: string; contactName: string | null; phone: string | null; email: string | null; taxId: string | null; address: string | null };
  trip: { id: string; number: string; status: string; originText: string | null; destText: string | null; distanceKm: string | number | null; startedAt: string | null; endedAt: string | null; shipmentOrderNo: string | null } | null;
  items: InvoiceItem[];
  createdByName: string | null;
  pdfUrl: string | null;
  uploadedUrl: string | null;
  pdfAvailable: boolean;
  balanceEgp: number;
}

export interface InvoiceSummary {
  outstandingEgp: number;
  outstandingCount: number;
  overdueEgp: number;
  overdueCount: number;
  paidMonthEgp: number;
  paidMonthCount: number;
  draftCount: number;
}

export const invoiceTone = (s: InvoiceStatus): 'neutral' | 'info' | 'success' | 'danger' | 'warning' =>
  s === 'DRAFT' ? 'neutral' : s === 'SENT' ? 'info' : s === 'PAID' ? 'success' : s === 'OVERDUE' ? 'danger' : 'warning';
